import Switch from 'components/Kizen/Switch';
import { useTranslation } from 'react-i18next';
import { EMPTY_OBJECT } from 'utility/fieldHelpers';
import { FIELD_TYPES } from 'utility/constants';
import Cols from 'components/Layout/Cols';

export default function TextOptions({ updateField, formData = EMPTY_OBJECT }) {
  const { t } = useTranslation();

  const supportsMarkdown = formData.type === FIELD_TYPES.LongText.type;

  const handleToggleMasked = (ev) => {
    updateField('meta', {
      ...formData.meta,
      isMasked: ev.currentTarget.checked,
    });
  };
  const handleToggleMarkdown = (ev) => {
    updateField('meta', {
      ...formData.meta,
      isMarkdown: ev.currentTarget.checked,
    });
  };

  return (
    <Cols columns={2} gutter="20px">
      <Switch
        label={t('Obscure Data Until Direct Interaction')}
        checked={formData.meta?.isMasked || false}
        onChange={handleToggleMasked}
        data-qa="obscure-data"
        removeMargin
        tooltip={t(
          'Text will be obfuscated with black circles until the content is either hovered or clicked into for editing.'
        )}
        tooltipMaxWidth={300}
        textPlacement="regular-top"
      />
      {supportsMarkdown ? (
        <Switch
          label={t('Allow Rich Text')}
          checked={formData.meta?.isMarkdown || false}
          onChange={handleToggleMarkdown}
          data-qa="enable-markdown"
          removeMargin
          tooltip={t(
            "This will apply markdown styling to any text formatted with markdown or via Kizen's WYSIWYG interface."
          )}
          tooltipMaxWidth={300}
          textPlacement="regular-top"
        />
      ) : null}
    </Cols>
  );
}
